var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-categories-link font-heading font-bold lg:font-body",on:{"click":function($event){_vm.hasOverlay ? _vm.updateActiveLink(_vm.linkText) : null}}},[_vm._v(" "+_vm._s(_vm.linkText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }